import { Injectable, EventEmitter } from '@angular/core';
import { SearchRecord, VendorResponseTypes, SearchVendors, CriminalSearchTypes, SearchPackage, VendorSelectValues, SearchFeeLookupPayload, VendorIdentifierLookupResponse } from '../packages-module/models/searchPackage';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ReferenceVerification, EmploymentVerification, ReferenceVerificationQuestion, VerificationCallPattern } from '../models/ApplicantDataResponses/ApplicantDataResponses';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { ObjectUpdatePayload } from '../models/screeningInvite';
import { CreditRepositories, SimpleCreditRepo, CreditScoreTypes } from '../models/ApplicantDataResponses/credit';
import { SimpleDataFilter } from '../models/simpleDataFilter';
import { Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { LocationData } from '../packages-module/models/locationData';
import {PaginationService} from '../shared-components-module/pagination-top/services/pagination.service';
import { ClientPackagePricing } from '../packages-module/models/clientPackagePrice';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class SearchPackageService {
  searchesSupported : Array<SearchRecord> = new Array<SearchRecord>();
  packagesLoaded : EventEmitter<boolean> = new EventEmitter();
  stateDataLoaded : EventEmitter<boolean> = new EventEmitter();
  /**
   * The Search Packages Available for this report
   */
  public get searchPackages() : SearchPackage[] {
    if(this.auth.UserInRole('StpAdmin'))
      return this._searchPackages;
    else
      return this._searchPackages.filter(sp => { return !sp.stpOnly })
  }
  
  _searchPackages : Array<SearchPackage> = [];
  totalPackagesCount : number;
  loading : boolean;
  stateArray : Array<string> = ['AL','AK','AZ','AR','CA','CO','CT','DC','DE','FL','GA','HI','ID','IL','IN','IA','KS','KY','LA','ME','MD','MA','MI','MN','MS','MO','MT',
  'NE','NV','NH','NJ','NM','NY','NC','ND','OH','OK','OR','PA','RI','SC','SD','TN','TX','UT','VT','VA','WA','WV','WI','WY'];

  creditRepositories : SimpleCreditRepo[] = [
    { name : 'Equifax', id : 0},
    { name : 'Experian', id : 1},
    { name : 'Transunion', id : 2},
  ];

  creditVendors : SimpleCreditRepo[] = [
    { name : 'Tazworks', id : 0},
    { name : 'TransUnion', id : 11}
  ];

  creditScoreTypes : SimpleCreditRepo[] = [
    { name : 'Fico', id : 0},
    { name : 'Vantage', id : 1}
  ];
  
  crimSearchVendors : VendorSelectValues[] = [
    { vendorName: 'Cleara', vendorId: 5 },
    { vendorName: 'Tazworks', vendorId: 0 },
    { vendorName: 'Wholesale', vendorId: 6 },
    { vendorName: 'Astute', vendorId: 12 }
  ]

  evictionVerSearchVendors : VendorSelectValues[] = [
    { vendorName: 'Cleara', vendorId: 5 },
    { vendorName: 'InformData', vendorId: 4 },
    { vendorName: 'Astute', vendorId: 12 }
  ]

  evSearchVendors : VendorSelectValues[] = [
    { vendorName: 'Cleara', vendorId: 5 },
    { vendorName: 'Tazworks', vendorId: 0 },
    { vendorName: 'Tracers', vendorId: 1 }
  ]

  idSearchVendors : VendorSelectValues[] = [
    // { vendorName: 'MasterCard', vendorId: 7 },
    { vendorName: 'Prove', vendorId: 10 }
  ]

  verificationCallPatterns : VerificationCallPattern[] = [
    { id: 1, key: '1C1D', prettyValue: '1 call over 1 day' },
    { id: 2, key: '3C3D', prettyValue: '3 calls over 3 days' }
  ]

  constructor(private http : HttpClient,
    private readonly paginationService: PaginationService,
    private auth: AuthService,
    private toast : ToastrService) {
    this.refreshSearchPackages();
  }

  editorConfig: AngularEditorConfig = {
      editable: true,
      spellcheck: true,
      height: 'auto',
      minHeight: '0',
      maxHeight: 'auto',
      width: 'auto',
      minWidth: '0',
      translate: 'yes',
      enableToolbar: true,
      showToolbar: true,
      placeholder: 'Enter notes here...',
      defaultParagraphSeparator: '',
      defaultFontName: '',
      defaultFontSize: '',
      fonts: [
          {class: 'arial', name: 'Arial'},
          {class: 'times-new-roman', name: 'Times New Roman'},
          {class: 'calibri', name: 'Calibri'},
          {class: 'comic-sans-ms', name: 'Comic Sans MS'}
        ],
      customClasses: [
        {
          name: 'Highlight Selection',
          class: 'highlight-this',
        },
        // {
        //   name: 'redText',
        //   class: 'redText'
        // },
        // {
        //   name: 'titleText',
        //   class: 'titleText',
        //   tag: 'h1',
        // },
      ],
    // uploadUrl: 'v1/image',
    sanitize: true,
    toolbarPosition: 'top',
  };

  editorReadOnlyConfig : AngularEditorConfig = {
    editable: false,
    spellcheck: true,
    height: 'auto',
    minHeight: '0',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: false,
    showToolbar: false,
    placeholder: 'Enter notes here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    sanitize: true,
    toolbarPosition: 'top',
};

  pipelineStages : any[] =  [
    { name: 'Not Run', id: 1 },
    { name: 'Pending', id: 2 },
    { name: 'Received', id: 3 },
    { name: 'Filtered', id: 4 },
    { name: 'Scored', id: 5 },
    { name: 'Pending Review', id: 6 },
    { name: 'QA Review', id: 7 },
    { name: 'Complete', id: 8 }
  ];

  searchEntryStates : any[] = [
    { name: 'Error', id: 1 },
    { name: 'Canceled', id: 2 },
    { name: 'Voided', id: 3 },
    { name: '', id: 4 },
    { name: 'Invoiced', id: 5 },
    { name: 'Paid', id: 6 }
  ];




  _stateData : LocationData[];
  public get stateData() :  LocationData[] {  
      return this._stateData;
  }

  loadStateData(state: string){
    this.getCountiesForState(state).subscribe((res : LocationData[])=> {

      this._stateData = res;
      this.stateDataLoaded.emit()
      return this._stateData;
    })
  }

  public get notRunSearchOptions(): SearchRecord[] {
    if(!this.searchesSupported) return null;
    return this.searchesSupported.filter(p => { return p.canShowInSearchFilter; });
  }


  refreshSearchPackages() : void {
    this.searchesSupported = [];
    // CREDIT
    let credit = new SearchRecord();
    credit.name = 'Credit Report';
    credit.searchType = VendorResponseTypes.Credit;
    credit.vendor = SearchVendors.TazWorks;
    credit.searchMeta = {score: true, repository : CreditRepositories.Transunion, creditScoreType : CreditScoreTypes.VANTAGE };

    // EVICTION
    // let eviction = new SearchRecord();
    // eviction.name = 'National Eviction Database [TH]';
    // eviction.searchType = VendorResponseTypes.Eviction;
    // eviction.searchMeta= {searchDepth: CriminalSearchTypes.National};
    // eviction.restrictedForClientId = [17];

    // let tracers_eviction = new SearchRecord();
    // tracers_eviction.name = 'National Eviction Database [TR]';
    // tracers_eviction.searchType = VendorResponseTypes.Eviction;
    // tracers_eviction.vendor = SearchVendors.Tracers
    // tracers_eviction.searchMeta= {};
    // tracers_eviction.restrictedForClientId = [17];

    // STATE EVICTION
    let stateEviction = new SearchRecord();
    stateEviction.name = 'State Eviction Database';
    stateEviction.searchType = VendorResponseTypes.Eviction;
    stateEviction.searchMeta= {searchDepth: CriminalSearchTypes.State};

    // CRIMINAL
    let criminal = new SearchRecord();
    criminal.name = 'National Criminal Database [TZ]';
    criminal.searchType = VendorResponseTypes.Criminal;
    criminal.vendor = SearchVendors.TazWorks;
    criminal.searchMeta= {searchDepth: CriminalSearchTypes.National};

    // COUNTY CRIMINAL
    let countyCriminal = new SearchRecord();
    countyCriminal.name = 'County Criminal Database';
    countyCriminal.searchType = VendorResponseTypes.Criminal;
    countyCriminal.vendor = SearchVendors.Wholesale;
    countyCriminal.searchMeta= {searchDepth: CriminalSearchTypes.County, isManuallyTriggered: true };

    // COUNTY CRIMINAL
    let nationalAliasCriminal = new SearchRecord();
    nationalAliasCriminal.name = 'National Alias Criminal Search';
    nationalAliasCriminal.searchType = VendorResponseTypes.Criminal;
    nationalAliasCriminal.vendor = SearchVendors.Cleara;
    nationalAliasCriminal.searchMeta= {searchDepth: CriminalSearchTypes.NationalAlias};

    // STATE CRIMINAL Database
    let stateCriminalDatabase = new SearchRecord();
    stateCriminalDatabase.name = 'State Criminal Database Search';
    stateCriminalDatabase.searchType = VendorResponseTypes.Criminal;
    stateCriminalDatabase.vendor = SearchVendors.Wholesale;
    stateCriminalDatabase.searchMeta= {searchDepth: CriminalSearchTypes.SingleState};

    //PERSON
    let person = new SearchRecord();
    person.name = 'Social Security Trace [TR]';
    person.searchType = VendorResponseTypes.Person
    person.vendor = SearchVendors.Tracers;
    person.searchMeta = {};
    person.restrictedForClientId = [17];

    //TAX LIENs AND JUDGEMENTS
    // DEPRECATED
    // let blj = new SearchRecord();
    // blj.name = 'TaxLiens Bankruptcies and Judgments';
    // blj.searchType = VendorResponseTypes.TaxLien,
    // blj.vendor = SearchVendors.Tracers;
    // blj.searchMeta = {};

    //Utah Justice Court Search
    let utcs = new SearchRecord();
    utcs.name = 'Utah Justice Court Search';
    utcs.searchType = VendorResponseTypes.Criminal;
    utcs.vendor = SearchVendors.UtahCourts;
    utcs.searchMeta =  {searchDepth: CriminalSearchTypes.UtahJusticeCourtScrape};

    //Utah District Court Search
    let utdcs = new SearchRecord();
    utdcs.name = 'Utah District Court Search';
    utdcs.searchType = VendorResponseTypes.Criminal;
    utdcs.vendor = SearchVendors.UtahCourts;
    utdcs.searchMeta =  {searchDepth: CriminalSearchTypes.UtahDistrictCourtScrape};

    //SJV Employment Verification Search
    let sjvEmp = new SearchRecord();
    sjvEmp.name = "Employment Verification";
    sjvEmp.searchType = VendorResponseTypes.Employment;
    sjvEmp.vendor = SearchVendors.SJV;
    sjvEmp.searchMeta = {isManuallyTriggered: true };

    let sjvRes = new SearchRecord();
    sjvRes.name = "Residence Verification";
    sjvRes.searchType = VendorResponseTypes.ResidenceVerification;
    sjvRes.vendor = SearchVendors.SJV;
    sjvRes.searchMeta = { isManuallyTriggered: true };

    let clearaCrim = new SearchRecord();
    clearaCrim.name = 'National Criminal Database';
    clearaCrim.searchType = VendorResponseTypes.Criminal;
    clearaCrim.vendor = SearchVendors.Cleara;
    clearaCrim.searchMeta = {searchDepth: CriminalSearchTypes.National, isManuallyTriggered: true};

    let clearaEvict = new SearchRecord();
    clearaEvict.name = 'National Eviction Database';
    clearaEvict.searchType = VendorResponseTypes.Eviction;
    clearaEvict.vendor = SearchVendors.Cleara;
    clearaEvict.searchMeta = { isManuallyTriggered: true };

    let clearaSkipTrace = new SearchRecord();
    clearaSkipTrace.name = 'Social Security Trace';
    clearaSkipTrace.searchType = VendorResponseTypes.Person;
    clearaSkipTrace.vendor = SearchVendors.Cleara;
    clearaSkipTrace.searchMeta = {};

    let mastercardIdentity = new SearchRecord();
    mastercardIdentity.name = 'Identity Verification';
    mastercardIdentity.searchType = VendorResponseTypes.IdentityVerification;
    mastercardIdentity.vendor = SearchVendors.Prove;
    mastercardIdentity.searchMeta = {};

    //Internal income verification
    let incomeVerification = new SearchRecord();
    incomeVerification.name = 'Income Verification';
    incomeVerification.searchType = VendorResponseTypes.IncomeVerification;
    incomeVerification.vendor = SearchVendors.RIQFIN;
    incomeVerification.searchMeta = {};
    
    let clearaOfac = new SearchRecord();
    clearaOfac.name = 'OFAC Search';
    clearaOfac.searchType = VendorResponseTypes.Criminal;
    clearaOfac.vendor = SearchVendors.Cleara;
    clearaOfac.searchMeta = { isManuallyTriggered: true, searchDepth: CriminalSearchTypes.Ofac };

    let sjvEvictionVerification = new SearchRecord();
    sjvEvictionVerification.name = 'Eviction Verification';
    sjvEvictionVerification.searchType = VendorResponseTypes.EvictionVerification;
    sjvEvictionVerification.searchMeta = { isManuallyTriggered: true };

    this.searchesSupported.push(credit);
    this.searchesSupported.push(mastercardIdentity);
    // this.searchesSupported.push(eviction);
    this.searchesSupported.push(stateEviction);
    this.searchesSupported.push(criminal);
    this.searchesSupported.push(stateCriminalDatabase);
    this.searchesSupported.push(countyCriminal);
    this.searchesSupported.push(person);
    // this.searchesSupported.push(blj);
    this.searchesSupported.push(utcs);
    this.searchesSupported.push(utdcs);
    this.searchesSupported.push(sjvEmp);
    this.searchesSupported.push(sjvRes);
    // this.searchesSupported.push(tracers_eviction);
    this.searchesSupported.push(nationalAliasCriminal);
    this.searchesSupported.push(clearaEvict);
    this.searchesSupported.push(clearaCrim);
    this.searchesSupported.push(clearaSkipTrace);
    this.searchesSupported.push(incomeVerification);
    this.searchesSupported.push(clearaOfac);
    this.searchesSupported.push(sjvEvictionVerification);

    //SCRSTP-1843: sort alphabetically
    this.searchesSupported.sort((a, b) => {
      if(a.name == b.name) return 0;
      if(a.name < b.name) return -1;
      if(a.name > b.name) return 1;

    });

  }

  addSearchToReport(screeningId : number, searchId : number) {
    return this.http.get(environment.baseURl + `/api/search/addsearch/${screeningId}/${searchId}`);
  }


  FetchSearchPackagesList()
  {
    var offset = (this.paginationService.currentPage -1) * this.paginationService.pageIncrement;

    this.loading = true;
    this.http.get(environment.baseURl + `/api/search/packages/list/${this.paginationService.pageIncrement}/${offset}`).subscribe((rsp: any)=>{
      this._searchPackages = rsp.listResult.map(sp =>{
        let serialized = Object.assign(new SearchPackage(),sp );
        return serialized;
      })
      this.totalPackagesCount = rsp.totalRecordsCount;
      this.loading = false;
      this.packagesLoaded.next(true);
    },(err : any)=>{
      this.toast.error('There was an error fetching search packages.', '', { disableTimeOut: true, closeButton: true});
      this.loading = false;
      this.packagesLoaded.next(false);
    })
  }

  FetchFullSearchPackagesListForUser(clientId : number)
  {
    this.loading = true;
    this.http.get(environment.baseURl + `/api/search/packages/${clientId}`).subscribe((rsp: any)=>{
      this._searchPackages = rsp.map(sp =>{
        let serialized = Object.assign(new SearchPackage(),sp );
        return serialized;
      })
      this.totalPackagesCount = rsp.totalRecordsCount;
      this.loading = false;
      this.packagesLoaded.next(true);
    },(err : any)=>{
      this.toast.error('There was an error fetching search packages.', '', { disableTimeOut: true, closeButton: true});
      this.loading = false;
      this.packagesLoaded.next(false);
    })

  }

  saveSearch(rec : SearchRecord) {
    return this.http.post<number>(environment.baseURl + `/api/search/savesearch`, rec);
  }

  AssociateSearchToPackage(searchId : number, pkgId : number){
    return this.http.get(environment.baseURl + `/api/search/associate/${searchId}/${pkgId}`);
  }

  RemoveSearchFromPackage(searchId : number, pkgId : number){
    return this.http.get(environment.baseURl + `/api/search/remove/${searchId}/${pkgId}`);
  }

  getCountiesForState(state : string = null) {
    if(state)
      return this.http.get(environment.baseURl + `/api/search/counties/${state}`);
    else 
      return this.http.get(environment.baseURl + `/api/search/counties`);
  }

  updateSearchStatus(aseId : number, pipelineStage : number) {
    return this.http.get(environment.baseURl + `/api/search/update/${aseId}/${pipelineStage}`);
  }

  runManualSearch(aseId : number) {
    return this.http.get(environment.baseURl + `/api/search/process/manual/${aseId}`);
  }

  markCommonNameSearch(aseId : number) {
    return this.http.get(environment.baseURl + `/api/search/commonName/${aseId}`);
  }

  refetchWholesaleEta(aseId: number) {
    return this.http.get(environment.baseURl + '/api/wholesale/eta/' + aseId, {responseType: 'text'});
  }

  getLatestVendorIdentifier(searchEntryId: number): Observable<VendorIdentifierLookupResponse> {
    return this.http.get<VendorIdentifierLookupResponse>(
      environment.baseURl + `/api/search/vendorIdentifier/${searchEntryId}`);
  }

  saveRefVerification(refVer : ReferenceVerification) {
    return this.http.post(environment.baseURl + `/api/sjv/reference`, refVer);
  }

  saveEmpVerification(empVer : EmploymentVerification) {
    return this.http.post(environment.baseURl + `/api/sjv/employment`, empVer);
  }

  updateResVer(updates : ReferenceVerification) : any{
    return this.http.post(environment.baseURl + `/api/sjv/update/ref`, updates);
  }

  updateEmpVer(updates : EmploymentVerification) : any{
    return this.http.post(environment.baseURl + `/api/sjv/update/emp`, updates);
  }

  saveVerificationQuestion(question : ReferenceVerificationQuestion) : any{
    return this.http.post(environment.baseURl + `/api/sjv/verificationQuestion`, question);
  }

  AssociatePackageToClient(clientId:number ,pkgId : number): Observable<Object>{
    return this.http.get(environment.baseURl + `/api/search/package/associate/${clientId}/${pkgId}`);
  }

  RemovePackageFromClient(clientId:number ,pkgId : number): Observable<Object>{
    return this.http.get(environment.baseURl + `/api/search/package/disassociate/${clientId}/${pkgId}`);
  }

  SaveSearchPackage(pkg: SearchPackage){
    return this.http.post(environment.baseURl + '/api/search/packages', pkg);
  }

  UpdatePackage(pkg: SearchPackage) {
    return this.http.post(environment.baseURl + `/api/search/packages/update`, pkg);
  }

  UpdateSearch(updates : SearchRecord) : Observable<Object>{
    return this.http.post(environment.baseURl + `/api/search/search/update`, updates);
  }


  FetchSearchPackageById(pkgId : any):  Observable<SearchPackage[]> {
    return this.http.get<SearchPackage[]>(environment.baseURl + `/api/search/package/${pkgId}`);
  }

  SaveClientSearchPackageOverride(override : ClientPackagePricing): Observable<Object>{
    return this.http.post(environment.baseURl + '/api/searchpackage/override', override);
  }

  UpdateClientSearchPackageOverride(override : ClientPackagePricing): Observable<Object>{
    return this.http.post(environment.baseURl + '/api/searchpackage/overrides/update', override);
  }

  GetClientSearchPackageOverride(clientId : number, packageId : number){
    return this.http.get<ClientPackagePricing>(environment.baseURl + `/api/searchpackage/overrides/${clientId}/${packageId}`);
  }

  GetClientSearchPackageOverrideList(clientId : number) {
    return this.http.get<ClientPackagePricing[]>(environment.baseURl + `/api/searchpackage/overrides/${clientId}`);
  }

  GetFeesForSearchPackage(pkg : SearchFeeLookupPayload): Observable<Object>{
    return this.http.post(environment.baseURl + `/api/searchfees`,pkg);
  }

  getDeepCleaningPreview(searchEntryId: number): Observable<any> {
    return this.http.get(`${environment.baseURl}/api/deepcleaning/preview/${searchEntryId}`);
  }

  logDeepCleaning(payload: any): Observable<any> {
    return this.http.post(`${environment.baseURl}/api/deepcleaning/log`, payload);
  }
}
